import { useState } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { TRoutes } from '../../shared/const'
import styles from './style.module.scss'

/*
 * Datenschutz-Hinweisstreifen am unteren Rand. Kein Consent-Banner: Die
 * Plattform setzt keine Cookies und keine Tracking-Dienste ein, gespeichert
 * wird nur technisch Notwendiges im localStorage (Anmelde-Token, Sprachwahl) —
 * dafür verlangt § 165 Abs 3 TKG keine Einwilligung. Der Streifen informiert
 * lediglich und verlinkt die Datenschutzerklärung. Die Bestätigung wird im
 * localStorage gemerkt, damit der Hinweis nur einmal pro Browser erscheint.
 */
const STORAGE_KEY = 'privacyNoticeDismissed'

function PrivacyBanner({ onDismissed }) {
	const { t } = useTranslation()
	const [dismissed, setDismissed] = useState(() => localStorage.getItem(STORAGE_KEY) === '1')

	if (dismissed) return null

	const onDismiss = () => {
		localStorage.setItem(STORAGE_KEY, '1')
		setDismissed(true)
		if (onDismissed) onDismissed()
	}

	return (
		<div className={styles.root} role="region" aria-label={t('Privacy notice')}>
			<span className={styles.text}>
				{t(
					'This platform does not use cookies or tracking services. Only technically necessary data (login, language selection) is stored locally in your browser.'
				)}{' '}
				<Link className={styles.link} to={TRoutes.DATENSCHUTZ}>
					{t('Privacy Statement')}
				</Link>
			</span>

			<button type="button" className={styles.button} onClick={onDismiss}>
				{t('Got it')}
			</button>
		</div>
	)
}

PrivacyBanner.propTypes = {
	onDismissed: PropTypes.func
}

export default PrivacyBanner
